import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const HclSatheeKendraForm = () => {
    const API_URL = process.env.REACT_APP_API_URL;
    const [kendras, setKendras] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    
    const initForm = {
        kendra_name: '', state: '', district: '', block: '', address: '', coordinator_name: '', mobile_number: '',
        govt_schools_count: 0, private_schools_count: 0, other_schools_count: 0,
        govt_colleges_count: 0, private_colleges_count: 0, other_colleges_count: 0,
        coaching_institutes_count: 0, ngo_details: '', shg_details: ''
    };
    const [form, setForm] = useState(initForm);

    useEffect(() => { loadKendras(); }, []);

    const loadKendras = () => {
        Axios.get(`${API_URL}/sathee/kendra`, { headers: { Authorization: localStorage.getItem('token') } })
            .then(res => setKendras(res.data.data))
            .catch(err => console.error(err));
    };

    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    const filteredKendras = kendras.filter(k => 
        k.kendra_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        k.id.toString().includes(searchTerm)
    );

    const handleEdit = (kendra) => {
        setForm({
            kendra_name: kendra.kendra_name || '', state: kendra.state || '', district: kendra.district || '',
            block: kendra.block || '', address: kendra.address || '', coordinator_name: kendra.coordinator_name || '',
            mobile_number: kendra.mobile_number || '', govt_schools_count: kendra.govt_schools_count || 0,
            private_schools_count: kendra.private_schools_count || 0, other_schools_count: kendra.other_schools_count || 0,
            govt_colleges_count: kendra.govt_colleges_count || 0, private_colleges_count: kendra.private_colleges_count || 0,
            other_colleges_count: kendra.other_colleges_count || 0, coaching_institutes_count: kendra.coaching_institutes_count || 0,
            ngo_details: kendra.ngo_details || '', shg_details: kendra.shg_details || ''
        });
        setIsEditing(true);
        setEditId(kendra.id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const cancelEdit = () => {
        setForm(initForm);
        setIsEditing(false);
        setEditId(null);
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        try {
            if (isEditing) {
                const res = await Axios.put(`${API_URL}/sathee/kendra/${editId}`, form, { headers: { Authorization: localStorage.getItem('token') } });
                toast.success(res.data.message || 'Updated successfully');
            } else {
                const res = await Axios.post(`${API_URL}/sathee/kendra`, form, { headers: { Authorization: localStorage.getItem('token') } });
                toast.success(res.data.message);
            }
            setForm(initForm);
            setIsEditing(false);
            setEditId(null);
            loadKendras();
        } catch (err) {
            toast.error(err.response?.data?.message || 'Failed to save');
        }
        setLoading(false);
    };

    const handleDelete = async id => {
        if (!window.confirm('Delete Kendra?')) return;
        try {
            await Axios.delete(`${API_URL}/sathee/kendra/${id}`, { headers: { Authorization: localStorage.getItem('token') } });
            toast.success('Deleted successfully');
            loadKendras();
        } catch (err) {
            toast.error('Failed to delete');
        }
    };

    const IStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box' };

    return (
        <div style={{ padding: 20 }}>
            <ToastContainer />
            <h2 style={{ marginBottom: 20 }}>Kendra Details</h2>
            <div style={{ background: '#fff', padding: 20, borderRadius: 10, boxShadow: '0 4px 10px rgba(0,0,0,0.05)', marginBottom: 30 }}>
                <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
                    <div><label>Kendra Name *</label><input required style={IStyle} name="kendra_name" value={form.kendra_name} onChange={handleChange} /></div>
                    <div><label>State *</label><input required style={IStyle} name="state" value={form.state} onChange={handleChange} /></div>
                    <div><label>District *</label><input required style={IStyle} name="district" value={form.district} onChange={handleChange} /></div>
                    <div><label>Block</label><input style={IStyle} name="block" value={form.block} onChange={handleChange} /></div>
                    <div><label>Address</label><input style={IStyle} name="address" value={form.address} onChange={handleChange} /></div>
                    <div><label>Coordinator Name</label><input style={IStyle} name="coordinator_name" value={form.coordinator_name} onChange={handleChange} /></div>
                    <div><label>Mobile Number</label><input style={IStyle} name="mobile_number" value={form.mobile_number} onChange={handleChange} /></div>

                    <div style={{ gridColumn: 'span 2' }}><h4>Nearby Details (10 KM Radius)</h4></div>
                    <div><label>Govt Schools Count</label><input type="number" style={IStyle} name="govt_schools_count" value={form.govt_schools_count} onChange={handleChange} /></div>
                    <div><label>Private Schools Count</label><input type="number" style={IStyle} name="private_schools_count" value={form.private_schools_count} onChange={handleChange} /></div>
                    <div><label>Other Schools Count</label><input type="number" style={IStyle} name="other_schools_count" value={form.other_schools_count} onChange={handleChange} /></div>
                    <div><label>Govt Colleges Count</label><input type="number" style={IStyle} name="govt_colleges_count" value={form.govt_colleges_count} onChange={handleChange} /></div>
                    <div><label>Private Colleges Count</label><input type="number" style={IStyle} name="private_colleges_count" value={form.private_colleges_count} onChange={handleChange} /></div>
                    <div><label>Other Colleges Count</label><input type="number" style={IStyle} name="other_colleges_count" value={form.other_colleges_count} onChange={handleChange} /></div>
                    <div><label>Coaching Institutes Count</label><input type="number" style={IStyle} name="coaching_institutes_count" value={form.coaching_institutes_count} onChange={handleChange} /></div>

                    <div style={{ gridColumn: 'span 2' }}><h4>Community Details</h4></div>
                    <div><label>NGO Details</label><input style={IStyle} name="ngo_details" value={form.ngo_details} onChange={handleChange} /></div>
                    <div><label>SHG Details</label><input style={IStyle} name="shg_details" value={form.shg_details} onChange={handleChange} /></div>

                    <div style={{ gridColumn: 'span 2', textAlign: 'right' }}>
                        {isEditing && (
                            <button type="button" onClick={cancelEdit} style={{ padding: '10px 20px', background: '#9ca3af', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', marginRight: 10 }}>
                                Cancel Edit
                            </button>
                        )}
                        <button type="submit" disabled={loading} style={{ padding: '10px 20px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>
                            {loading ? 'Saving...' : isEditing ? 'Update Kendra' : 'Save Kendra'}
                        </button>
                    </div>
                </form>
            </div>

            <div style={{ background: '#fff', padding: 20, borderRadius: 10, boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
                    <h3 style={{ margin: 0 }}>Existing Kendras</h3>
                    <input 
                        style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', width: '250px' }}
                        placeholder="Search by Name or ID..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 10 }}>
                    <thead><tr style={{ background: '#f3f4f6', textAlign: 'left' }}><th>ID</th><th>Name</th><th>State</th><th>Coordinator</th><th>Mobile</th><th>Actions</th></tr></thead>
                    <tbody>
                        {filteredKendras.map(k => (
                            <tr key={k.id} style={{ borderBottom: '1px solid #ddd' }}>
                                <td style={{ padding: 10 }}>{k.id}</td>
                                <td>{k.kendra_name}</td>
                                <td>{k.state}</td>
                                <td>{k.coordinator_name}</td>
                                <td>{k.mobile_number}</td>
                                <td>
                                    <button onClick={() => handleEdit(k)} style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 10px', cursor: 'pointer', marginRight: 5 }}>Edit</button>
                                    <button onClick={() => handleDelete(k.id)} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 10px', cursor: 'pointer' }}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {filteredKendras.length === 0 && <p style={{ textAlign: 'center', padding: 20, color: '#666' }}>No kendras found.</p>}
            </div>
        </div>
    );
};

export default HclSatheeKendraForm;
